import * as React from 'react';
import { storyblokEditable, type SbBlokData } from '@storyblok/react';

import type { FooterLinkStoryblok, StoryblokMultilink } from '../../types/storyblok';
import { MultilinkLink } from '../ui/MultilinkLink';

interface FooterLinkProps {
  blok: FooterLinkStoryblok;
}

const resolveDefaultText = (link: StoryblokMultilink): string => {
  if (link.linktype === 'story' && link.story?.name) return link.story.name;
  if (link.linktype === 'url') return link.url || link.cached_url;
  return link.cached_url || '';
};

export const FooterLink: React.FC<FooterLinkProps> = ({ blok }) => {
  // Type-gen narrows `blok.link` to exclude asset/email, but Storyblok runtime
  // content can drift from types, so widen for the defensive guard.
  const link = blok.link as StoryblokMultilink | undefined;
  if (!link || link.linktype === 'asset') return null;

  const visibleText = blok.label || resolveDefaultText(link);

  return (
    <li {...storyblokEditable(blok as unknown as SbBlokData)}>
      <MultilinkLink to={link} className="text-gray-300 hover:text-neutral-white">
        {visibleText}
      </MultilinkLink>
    </li>
  );
};
